import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import "../../css/residency/ManageResidencySeeMore.css";
import "../../css/Manage.css";
import { toast } from "react-toastify";
import ResidencyApi from "../../api/residencyApi";
import moment from "moment";

const ManageResidencySeeMore = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [item, setItem] = useState();

  useEffect(() => {
    ResidencyApi.Get(id)
      .then((res) => setItem(res.data.data.content))
      .catch(() => toast("서버에 문제가있습니다. 잠시후 다시 시도해주세요."));
  }, []);

  return (
    <div className="Manage-container">
      <section className="Manage-contents">
        <div className="go-back-container-residency-seemore">
          <div
            className="go-back"
            onClick={() => {
              navigate(-1);
            }}
          >
            <Link>
              <img src="\img\chevron-left.svg" />
              <span>뒤로가기</span>
            </Link>
          </div>
          {item?.state === "BEFORE_START" && !item?.reservation && (
            <div>
              <Link to={{ pathname: `/admin/reservation/${id}` }} state={item}>
                숙소 지정
              </Link>
            </div>
          )}
          {item?.state === "BEFORE_START" && item?.reservation && (
            <div>
              <Link
                to={{
                  pathname: `/admin/reservation/${item?.reservation.id}/change`,
                }}
                state={item}
              >
                숙소 지정
              </Link>
            </div>
          )}
        </div>
        <div className="Manage-form manage-form-residency-see-more">
          <span>거주권 정보</span>
          <div className="Manage-form-view-details">
            <span>유저명</span>
            <Link style={{ color: "#1E90FF" }}>{item?.member?.name}</Link>
          </div>
          <div className="Manage-form-view-details">
            <span>주문자명</span>
            <span>{item?.ordererName}</span>
          </div>
          <div className="Manage-form-view-details">
            <span>휴대전화</span>
            <span>{item?.ordererTel}</span>
          </div>
          <div className="Manage-form-view-details">
            <span>이메일</span>
            <span>{item?.ordererEmail}</span>
          </div>
          <div className="Manage-form-view-details">
            <span>상태</span>
            <span>
              {item?.state === "BEFORE_START"
                ? "시작 전"
                : item?.state === "IN_USE"
                  ? "사용중"
                  : item?.state === "DONE"
                    ? "사용 완료"
                    : "취소"}
            </span>
          </div>
          {item?.cancelReason && (
            <div className="Manage-form-view-details">
              <span>취소사유</span>
              <span>{item?.cancelReason}</span>
            </div>
          )}
          <div className="Manage-form-view-details">
            <span>시작일</span>
            <span>{moment(item?.startAt).local().format("YYYY/MM/DD")}</span>
          </div>
          <div className="Manage-form-view-details">
            <span>종료일</span>
            <span>{moment(item?.endAt).local().format("YYYY/MM/DD")}</span>
          </div>
          <div className="Manage-form-view-details">
            <span>원가</span>
            <span>{`${item?.originPrice ?? 0} 원`}</span>
          </div>
          <div className="Manage-form-view-details">
            <span>결제금액</span>
            <span>{`${item?.paymentPrice ?? 0} 원`}</span>
          </div>
          <div className="Manage-form-view-details">
            <span>할인가</span>
            <span>{`${
              Number(item?.couponDiscountPrice ?? 0) +
              Number(item?.useMileage ?? 0)
            } 원`}</span>
          </div>
          {item?.reservation && (
            <>
              <span>예약 정보</span>
              <div className="Manage-form-view-details">
                <span>숙소명</span>
                <span>{item.reservation.room?.accomodation?.name ?? ""}</span>
              </div>
              <div className="Manage-form-view-details">
                <span>객실명</span>
                <span>{item.reservation.room?.name ?? ""}</span>
              </div>
              <div className="Manage-form-view-details">
                <span>예약일</span>
                <span>
                  {moment(item.reservation.createdAt ?? "")
                    .local()
                    .format("YYYY/MM/DD")}
                </span>
              </div>
              <div className="Manage-form-view-details">
                <span>가격</span>
                <span>{`${item.reservation.room?.price ?? 0} 원`}</span>
              </div>
              {/* <div className="Manage-form-view-details">
                <span>주문번호</span>
                <span>{item.reservation.orderNumber} </span>
              </div> */}
              <div className="Manage-form-view-details">
                <span>중요안내</span>
                <span>{item.reservation.notice ?? "-"}</span>
              </div>
              <div className="Manage-form-view-details">
                <span>객실 이미지</span>
                <div className="program-detail-img">
                  <img src={item.reservation.room?.imageUrl} />
                </div>
              </div>
            </>
          )}
        </div>
      </section>
    </div>
  );
};

export default ManageResidencySeeMore;
